<!-- Modal preview component -->
<mat-dialog-actions align="center">
  <h1 class="style-text">
    {{fileName}}
  </h1>
</mat-dialog-actions>

<mat-dialog-actions align="end">
  <button class="style-button" mat-dialog-close>
    <mat-icon>close</mat-icon> {{'modal.file.close' | transloco}}
  </button>
</mat-dialog-actions>


<mat-dialog-content class="file-preview-dialog-content">

    <app-drake-file-preview [fileId]="file.id" [heightMode]="'FULL'"></app-drake-file-preview>

  <!-- <div *ngIf="isImageFile(file.fileName)">
    <img [src]="fileUrl" alt="File Preview">
  </div>
  <div *ngIf="isPdfFile(file.fileName)">
    <app-drake-file-preview [fileId]="file.id" [heightMode]="'FULL'"></app-drake-file-preview>
    <embed [src]="fileUrl"/>
  </div>
  <div *ngIf="isVideoFile(file.fileName)">
    <video controls [src]="fileUrl" width="100%" height="auto"></video>
  </div>
  <div *ngIf="!isImageFile(file.fileName) && !isPdfFile(file.fileName) && !isVideoFile(file.fileName)">
    <span>{{'modal.file.noPreview' | transloco}}</span>
  </div> -->
</mat-dialog-content>
